import React, { ReactElement } from 'react';

export default function NotFound(): ReactElement {
    return (
        <main>
            <h1>Not Found</h1>
        </main>
    );
}
